import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "userState",
  initialState: {
    isLoggedIn: false,
    token: null,
    userEmail: "",
    faculty_name: "",
    faculty_id: "",
    isAuthenticated: false,
    uuid: "",
    notifications: [],
    userName: "",
    Uid: "",
    userType: "",
    carte: [],
    showCartModal: false,
    mustChangePswd: 0,
  },
  reducers: {
    setMustChangePswd: (state, action) => {
      state.mustChangePswd = action.payload;
    },
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setCredentials: (state, action) => {
      const {
        token,
        user_type,
        uuid,
        email,
        userName,
        faculty_name,
        faculty_id,
        mustChangePswd,
      } = action.payload;
      state.token = token;
      state.userType = user_type;
      state.uuid = uuid;
      state.userEmail = email;
      state.userName = userName;
      state.isAuthenticated = true;
      state.faculty_name = faculty_name;
      state.faculty_id = faculty_id;
      state.mustChangePswd = mustChangePswd;
    },
    clearCredentials: (state) => {
      state.token = "";
      state.userType = null;
      state.uuid = null;
      state.userEmail = null;
      state.userName = null;
      state.isAuthenticated = false;
      state.faculty_name = "";
      state.faculty_id = "";
      state.mustChangePswd = 0;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
    },

    setUid: (state, action) => {
      state.Uid = action.payload;
    },
    showCartModal: (state) => {
      state.showCartModal = true;
    },
    hideCartModal: (state) => {
      state.showCartModal = false;
    },
    loggedIn: (state) => {
      state.isLoggedIn = true;
    },
    loggedOut: (state) => {
      state.isLoggedIn = false;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    clearNotifications: (state, action) => {
      state.notifications = [];
    },
    deleteNotification: (state, action) => {
      const n = [...state.notifications].filter(
        (notification) => notification.NotificationID !== action.payload
      );
      state.notifications = n;
    },
    markAllNotificationsAsRead: (state) => {
      const notifications = [...state.notifications];
      state.notifications = notifications.map((notification) => ({
        ...notification,
        Status: "Read",
      }));
    },
    markNotificationAsRead: (state, action) => {
      const notifications = [...state.notifications];
      const updatedNotifications = notifications.map((notification) =>
        notification.NotificationID === action.payload
          ? { ...notification, Status: "Read" }
          : notification
      );
      state.notifications = updatedNotifications;
    },
    canNotBorrowBooks: (state) => {
      state.canBorrowBooks = false;
    },
    canBorrowBooks: (state) => {
      state.canBorrowBooks = true;
    },
    clearCarte: (state) => {
      state.carte = [];
    },
    addToCarte: (state, action) => {
      const new_obj = action.payload;
      const prevState = [...state.carte];
      if (!prevState.some((obj) => obj.TitleID === new_obj.TitleID)) {
        state.carte = [...state.carte, action.payload];
      }
    },
    populateCarte: (state, action) => {
      const cartItems = action.payload;
      // const prevState = [...state.carte];
      state.carte = cartItems;
      // if (!prevState.some((obj) => obj.TitleID === new_obj.TitleID)) {
      //   state.carte = [...state.carte, action.payload];
      // }
    },
    removeFromCarte: (state, action) => {
      state.carte = [...state.carte].filter(
        (obj) => obj.TitleID != action.payload
      );
    },
  },
});
export const {
  setUserType,
  setCredentials,
  logout,
  loggedIn,
  loggedOut,
  setNotifications,
  clearNotifications,
  canBorrowBooks,
  canNotBorrowBooks,
  clearCarte,
  addToCarte,
  populateCarte,
  removeFromCarte,
  showCartModal,
  hideCartModal,
  setUid,
  markNotificationAsRead,
  deleteNotification,
  markAllNotificationsAsRead,
  clearCredentials,
  setMustChangePswd,
} = userSlice.actions;
export default userSlice.reducer;
